import React from 'react';
import ConfigUtils from '../../classes/utilities/ConfigUtils';

interface IVersionDisplayProps
{
	style?: React.CSSProperties;
}

/**
 * @export
 * @returns a div containing the application's version as defined in the config file
 */
const VersionDisplay = React.forwardRef((props: IVersionDisplayProps, forwardedRef?: React.ForwardedRef<HTMLDivElement>) =>
{
	return (
		<div ref={forwardedRef}
			style={props.style}
		>
			Version: {ConfigUtils.getProductVersionBuild()}
		</div>
	)
});

export default VersionDisplay;